<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="cover" id="cover">
<img alt="What Lies in the Dark" class="cover-image" role="doc-cover" src="images/what-lies-in-the-dark.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?3692e64c